import { memo } from 'react'
import { Route as ReactRoute } from 'react-router-dom'

import Seo from 'components/layout/Seo'
import { useLegalInfo } from 'api/hooks/queries/useLegalInfo'

import LoadingView from '../ProtectedRoute/components/LoadingView'

import { PublicRouteProps } from '.'

const PublicRoute = ({ meta, ...rest }: PublicRouteProps) => {
  const { component: Component, ...routeProps } = rest
  const legalInfo = useLegalInfo()

  if (legalInfo.isLoading) {
    return (
      <div style={{ alignSelf: 'center', width: '100%', textAlign: 'center' }}>
        <LoadingView />
      </div>
    )
  }

  return (
    <ReactRoute
      {...routeProps}
      render={props => (
        <>
          <Seo {...meta} />
          {/*
          // @ts-ignore*/}
          <Component {...props} {...routeProps} meta={meta} />
        </>
      )}
    />
  )
}

export default memo(PublicRoute)
